'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';
import { HomeIcon, RefreshCcwIcon, ServerCrashIcon, ShieldXIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
const ErrorPage = t0 => {
  const $ = _c(59);
  const {
    error,
    reset
  } = t0;
  const t = useTranslations();
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      console.error(error);
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== error.message) {
    t3 = error.message?.match(/^(\d{3}):/);
    $[3] = error.message;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const statusMatch = t3;
  const statusCode = statusMatch ? statusMatch[1] : null;
  let t4;
  if ($[5] !== error.message || $[6] !== error.name || $[7] !== statusCode) {
    t4 = statusCode === "403" || error.message?.includes("Forbidden") || error.name === "ForbiddenError";
    $[5] = error.message;
    $[6] = error.name;
    $[7] = statusCode;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const isForbidden = t4;
  let t5;
  if ($[9] !== error.message || $[10] !== statusCode) {
    t5 = statusCode === "503" || error.message?.includes("Backend service unavailable") || error.message?.includes("Connection failed");
    $[9] = error.message;
    $[10] = statusCode;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const isBackendDown = t5;
  const isBadRequest = statusCode === "400";
  const errorCode = isForbidden ? "403" : isBackendDown ? "503" : isBadRequest ? "400" : statusCode || "500";
  let t6;
  if ($[12] !== isBackendDown || $[13] !== isBadRequest || $[14] !== isForbidden || $[15] !== t) {
    t6 = isForbidden ? t("forbidden_access") : isBackendDown ? "Service Unavailable" : isBadRequest ? "Bad Request" : t("server_error");
    $[12] = isBackendDown;
    $[13] = isBadRequest;
    $[14] = isForbidden;
    $[15] = t;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const errorTitle = t6;
  let t7;
  if ($[17] !== isBackendDown || $[18] !== isBadRequest || $[19] !== isForbidden || $[20] !== t) {
    t7 = isForbidden ? t("do_not_hove_authority") : isBackendDown ? "Backend service is currently unavailable. Please try again later." : isBadRequest ? "The request cannot be processed." : t("server_error_description");
    $[17] = isBackendDown;
    $[18] = isBadRequest;
    $[19] = isForbidden;
    $[20] = t;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const errorDescription = t7;
  let t8;
  if ($[22] !== isForbidden) {
    t8 = <div className="mb-4 flex justify-center text-red-500">{isForbidden ? <ShieldXIcon className="h-20 w-20" /> : <ServerCrashIcon className="h-20 w-20" />}</div>;
    $[22] = isForbidden;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== errorCode) {
    t9 = <h1 className="animate-bounce text-4xl font-bold tracking-tighter sm:text-5xl">{errorCode}</h1>;
    $[24] = errorCode;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== errorTitle) {
    t10 = <h2 className="mb-5 text-2xl font-semibold tracking-tight sm:text-3xl">{errorTitle}</h2>;
    $[26] = errorTitle;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== errorDescription) {
    t11 = <p className="text-gray-500">{errorDescription}</p>;
    $[28] = errorDescription;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== error.message || $[31] !== isForbidden || $[32] !== t) {
    t12 = error.message && !isForbidden && <p className="text-red-500">{t("something_went_wrong")}</p>;
    $[30] = error.message;
    $[31] = isForbidden;
    $[32] = t;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t10 || $[35] !== t11 || $[36] !== t12 || $[37] !== t8 || $[38] !== t9) {
    t13 = <div className="space-y-3">{t8}{t9}{t10}{t11}{t12}</div>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t12;
    $[37] = t8;
    $[38] = t9;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <HomeIcon className="mr-2 h-4 w-4" />;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== t) {
    t15 = t("return_to_home");
    $[41] = t;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== t15) {
    t16 = <Link href="/" onClick={_temp} className="inline-flex h-10 items-center rounded-md bg-gray-900 px-8 text-sm font-medium text-gray-50 shadow transition-colors hover:bg-gray-900/90 focus-visible:ring-1 focus-visible:ring-gray-950 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 dark:bg-gray-50 dark:text-gray-900 dark:hover:bg-gray-50/90 dark:focus-visible:ring-gray-300">{t14}{t15}</Link>;
    $[43] = t15;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== reset) {
    t17 = () => reset();
    $[45] = reset;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <RefreshCcwIcon className="mr-2 h-4 w-4" />;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== t) {
    t19 = t("try_again");
    $[48] = t;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== t17 || $[51] !== t19) {
    t20 = <Button variant="secondary" onClick={t17}>{t18}{t19}</Button>;
    $[50] = t17;
    $[51] = t19;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  let t21;
  if ($[53] !== t16 || $[54] !== t20) {
    t21 = <div className="flex items-center justify-center gap-x-6">{t16}{t20}</div>;
    $[53] = t16;
    $[54] = t20;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  let t22;
  if ($[56] !== t13 || $[57] !== t21) {
    t22 = <div className="flex min-h-screen items-center px-4 py-12 sm:px-6 md:px-8 lg:px-12 xl:px-16"><div className="w-full space-y-6 text-center">{t13}{t21}</div></div>;
    $[56] = t13;
    $[57] = t21;
    $[58] = t22;
  } else {
    t22 = $[58];
  }
  return t22;
};
export default ErrorPage;
function _temp(e) {
  e.preventDefault();
  window.location.href = "/";
}